import { pageFrame } from '../page-frame';
import DataItemsSection from './components/DataItemsSection';
import DifferentiationSection from './components/DifferentiationSection';
import EngagementSection from './components/EngagementSection';
import HeroSection from './components/HeroSection';
import MotionAsDataSection from './components/MotionAsDataSection';
import VideoSection from './components/VideoSection';

export default function DataPage() {
  return (
    <div
      className={`${pageFrame} flex flex-col [--vertical-spacing:64px] lg:[--vertical-spacing:112px]`}
    >
      <HeroSection />
      <VideoSection />
      <MotionAsDataSection />
      <DataItemsSection />
      <DifferentiationSection />
      <EngagementSection />
    </div>
  );
}
